module.exports = "../dist/img/product-detail-2-21.c766.jpg";